import { Grid } from '@material-ui/core';
import { isLoggedIn } from 'api/UserApi';
import { Colors, Text } from 'library';
import React from 'react';
import { IGroupMember } from '../models';
import MemberAvatar from './MemberAvatar';

export default function MemberInfo({ member, avatarClasses }: { member: IGroupMember; avatarClasses: string }) {
    function getMemberName() {
        if (isLoggedIn()) {
            return <Text variant="body1">{`${member.first_name} ${member.last_initial}`}</Text>;
        }
        return (
            <Text
                variant="body1"
                textStyle={{ color: 'transparent', textShadow: '0 0 5px rgba(0,0,0,0.5)', display: 'inline' }}
            >
                {`${member.first_name} ${member.last_initial}`}
            </Text>
        );
    }

    function getLastActive() {
        if (isLoggedIn()) {
            return (
                <Text textStyle={{ padding: 0, color: Colors.grey }} variant="deprecatedCaption">
                    Last active {member.last_active}
                </Text>
            );
        }
        return (
            <Text variant="deprecatedCaption" textStyle={{ padding: 0, color: Colors.grey }}>
                Last active{' '}
                <Text
                    variant="deprecatedCaption"
                    textStyle={{ color: 'transparent', textShadow: '0 0 5px rgba(0,0,0,0.5)', display: 'inline' }}
                >
                    {member.last_active}
                </Text>
            </Text>
        );
    }
    return (
        <Grid
            xs={12}
            container
            item
            direction="row"
            style={{
                paddingBottom: 20,
                alignItems: 'center',
            }}
        >
            <MemberAvatar member={member} classes={avatarClasses} />
            <Grid xs={9} container item direction="column" style={{ paddingLeft: 15 }}>
                {getMemberName()}
                {getLastActive()}
            </Grid>
        </Grid>
    );
}
